/**
 * Waits for the next frame to finish: it asks the loop for one (an idle loop
 * runs it) and resolves after its render phase. What's pending when it's
 * called (a camera change, world edits the bridge flushes each frame) is then
 * drawn, so a caller that reads the result back sees the current state.
 */
import type { FrameLoop } from "./FrameLoop";

export function nextFrame(loop: FrameLoop): Promise<void> {
  return new Promise((resolve) => {
    const stop = loop.register("render", () => {
      stop();
      resolve();
    });
    loop.invalidate("next frame");
  });
}
